import React from 'react'
import Cost from './cost'
import {
  CoachName,
  DetailsContainer,
  LocationDistance,
  VerticalDivider,
} from 'components/search/result-card'

export default function Details({ hit }) {
  return (
    <DetailsContainer>
      <Cost hit={hit} />
      <VerticalDivider />
      <LocationDistance hit={hit} />
      <VerticalDivider />
      <CoachName hit={hit} />
    </DetailsContainer>
  )
}
